import React, {useState,useEffect} from "react";

import { RangeSlider as MantineRangeSlider, Slider as MantineSlider} from '@mantine/core';


export const RangeSlider : React.FC<RangeSliderProps> = (props : RangeSliderProps) : JSX.Element => {

    let [value, setValue] = useState(props.value);
    const paddingBottom : string = props.paddingBottom ? props.paddingBottom : "18px"


    return (
        <MantineRangeSlider 
            marks={props.sliderOption}
            minRange={0}
            min={0}
            max={props.sliderOption.length - 1}
            step={1}
            value={value}
            label={null}
            onChange={(v) => setValue(v)}
            onChangeEnd={(v) => props.onChangeEnd(v)}
            styles={(theme) => {

                return {
                    root: {
                        width: "100%",
                        paddingBottom: paddingBottom 
                    },
                    markLabel: {
                        fontSize: 8,
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        textAlign: "center",
                        maxWidth: "60px", 
                        overflow: "hidden",

                    },
                };
            }}
      />
    )  

};


export const Slider : React.FC<SingleSliderProps> = (props : SingleSliderProps) : JSX.Element => {
    
    let [value, setValue] = useState(props.value);
    const paddingBottom : string = props.paddingBottom ? props.paddingBottom : "18px"

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);


    return (
        <MantineSlider 
            marks={props.sliderOption}
            min={0}
            max={props.sliderOption.length - 1}
            step={1}
            value={value}
            label={null}
            onChange={(v) => setValue(v)}
            onChangeEnd={(v) => props.onChangeEnd(v)}
            styles={(theme) => {

                return {
                    root: {
                        width: "100%",
                        paddingBottom: paddingBottom 
                    },
                    markLabel: {
                        fontSize: 8,
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        textAlign: "center",
                        maxWidth: "60px", 
                        overflow: "hidden",

                    },
                };
            }}
      />
    )  

};


interface SliderOption {
    value : number;
    label : string;
}


interface BaseSliderProps {
    readonly sliderOption: SliderOption[];
    readonly onChangeEnd: (value: any) => void;
    readonly paddingBottom?: string;
  }
  
  interface SingleSliderProps extends BaseSliderProps {
    readonly value: number;
  }
  
  interface RangeSliderProps extends BaseSliderProps {
    readonly value: [number, number];
  }